import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/Logo.png';
import { NavLink } from 'react-router-dom';

function Header() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleOffcanvas = () => {
        setIsOpen(!isOpen);
    };

    return (
        <>
            <nav className="navbar navbar-expand-xl " style={{
                backgroundColor: "#FCFCF7",
                position: "fixed",
                top: 0,
                width: "100%",
                zIndex: 1000,
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
            }}>
                <div className="container-fluid">
                    <Link to='/'> <img src={logo} alt="Logo" width="140px" /> </Link>
                    <button className="navbar-toggler" type="button" onClick={toggleOffcanvas}>
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''} `} id="navbarSupportedContent">

                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <NavLink
                                    to="/"
                                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                    Home
                                </NavLink>
                            </li>
                            {/* <li className="nav-item">
                                <NavLink
                                    to="/about"
                                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                    About
                                </NavLink>
                            </li> */}
                            <li className="nav-item">
                                <NavLink
                                    to="/service/1/Pre-wedding"
                                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                    Pre-Wedding
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/service/2/Wedding"
                                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                    Wedding
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/video"
                                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                    Films
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink
                                    to="/contact"
                                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                    Contact
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default Header;
